import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface SidebarState {
  isExpanded: boolean;
  toggleExpanded: () => void;
  setExpanded: (isExpanded: boolean) => void;
}

export const useSidebarStore = create<SidebarState>()(
  persist(
    (set, get) => ({
      isExpanded: true, // Default expanded
      toggleExpanded: () => set({ isExpanded: !get().isExpanded }),
      setExpanded: (isExpanded) => set({ isExpanded }),
    }),
    {
      name: 'lift-sidebar-state',
      version: 1,
    }
  )
);
